import * as R from 'ramda'

/**
 * Get message icon color by status number
 *
 * Rules:
 *  - 0 = Message not sent
 *  - 1 = Message sent to mobile
 *  - 2 = Message sent, awaiting acknowledgement of receipt
 *  - 3 = Message sent to mobile without acknowledgement of receipt
 *  - 4 = Waiting for mobile connection
 *  - 5 = Message not sent, customer cancellation
 *  - 6 = Message not sent, message overwritten
 *  - 7 = Mobile unreachable
 *  - 8 = Message read
 *
 * @function getMessageIconColorFromStatus
 * @param {string} statusNumber
 * @returns
 */
export function getMessageIconColorFromStatus(statusNumber) {
  const status = parseInt(String(statusNumber))

  if ([0, 1, 2, 3, 4, 5, 6, 7].includes(status)) {
    return 'var(--color-regent-grey)'
  }

  if ([8].includes(status)) {
    return 'var(--color-green)'
  }

  // fallback
  return 'var(--color-red)'
}

/**
 * We have a planned messages table that groups planned messages by day.
 *
 * @param {*} items
 * @returns
 */
export function groupPlannedMessagesByDay(items) {
  let grouped = {}
  items.forEach((item) => {
    let id = window.btoa(
      JSON.stringify(R.omit(['id', 'dayId', 'dayCode', 'updatedAt'], item))
    )
    if (!grouped[id]) {
      grouped[id] = { ...item }
    }
    if (!grouped[id].dayIds && !grouped[id].dayCodes && !grouped[id].ids) {
      grouped[id].dayIds = []
      grouped[id].dayCodes = []
      grouped[id].ids = [] //planned message ids
      grouped[id].plannedMessages = []
    }
    grouped[id].dayIds.push(item.dayId)
    grouped[id].dayCodes.push(item.dayCode)
    grouped[id].ids.push(item.id)
    grouped[id].plannedMessages.push(item)
  })
  console.log('groupPlannedMessagesByDay', {
    grouped,
  })
  return Object.keys(grouped).reduce((arr, key) => {
    let item = grouped[key]
    item.id = grouped[key].ids.join('_')
    arr.push(item)
    return arr
  }, [])
}
